let tries = 0;

function waitUntilGALoads(cb) {
    const ga = (window as any).ga;

    if (ga && ga.getAll) {
        return cb();
    }

    if (tries === 4) {
        return cb("GA didn't load");
    }

    tries++;
    setTimeout(() => waitUntilGALoads(cb), tries * 100);
}

export const getGoogleClientIdAsync: () => Promise<number> = () =>
    new Promise((resolve) => {
        // const ga = (window as any).ga;
        // if (!ga) {
        //     return resolve(123456.3);
        // }

        waitUntilGALoads((err) => {
            if (err) {
                return resolve(123456.1);
            }

            const ga = (window as any).ga;

            ga((defaultTracker) => {
                if (defaultTracker) {
                    return resolve(defaultTracker.get('clientId'));
                }

                const allTrackers = ga.getAll();

                if (allTrackers.length) {
                    const targetTracker = allTrackers[0];

                    if (typeof targetTracker.get === 'function') {
                        return resolve(targetTracker.get('clientId'));
                    }
                }

                resolve(123456.2);
            });
        });
    });

export const trackLogin = (userId: string) => {
    const ga = (window as any).ga;
    const dataLayer = (window as any).dataLayer;

    if (!dataLayer) {
        console.warn('No GA found');

        return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
        dataLayer.push({
            event: 'login',
            userId: userId,
            eventCallback: (() => {
                let timer;

                if (!ga || !ga.create) {
                    timer = setTimeout(resolve, 3000);
                }

                return () => {
                    if (timer) {
                        clearTimeout(timer);
                    }

                    resolve();
                };
            })()
        });
    });
};

export const trackSignup = (userId: string) => {
    const ga = (window as any).ga;
    const dataLayer = (window as any).dataLayer;

    if (!dataLayer) {
        console.warn('No GA found');

        return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
        dataLayer.push({
            event: 'signup',
            userId: userId,
            eventCallback: (() => {
                let timer;

                if (!ga || !ga.create) {
                    timer = setTimeout(resolve, 3000);
                }

                return () => {
                    if (timer) {
                        clearTimeout(timer);
                    }

                    resolve();
                };
            })()
        });
    });
};

export const trackSignupDetails = (userId: string) => {
    const ga = (window as any).ga;
    const dataLayer = (window as any).dataLayer;

    if (!dataLayer) {
        console.warn('No GA found');

        return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
        dataLayer.push({
            event: 'signup_v2',
            userId: userId,
            eventCallback: (() => {
                let timer;

                if (!ga || !ga.create) {
                    timer = setTimeout(resolve, 3000);
                }

                return () => {
                    if (timer) {
                        clearTimeout(timer);
                    }

                    resolve();
                };
            })()
        });
    });
};
